/**
 * Rendering of a booking's or reservation's stored question responses, shared
 * by the details modals (PRO-1514). Responses are a name -> answer map whose
 * answer is a string or, for multi-select questions, a list of them.
 */

export function getQuestionNames(responses: any): string[] {
  return responses ? Object.keys(responses) : [];
}

export function formatQuestionAnswer(value: any): string {
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  return value;
}
